import { SET_ERROR, RESET_ERROR } from "../actions/error";

const initialState = {
  message: "An error has occurred. Please try again or contact us at (888) 316-5813 for assistance.",
  display: false
};

const service = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return { ...state, ...action.payload };
    case RESET_ERROR:
    return initialState;
    default:
      return state;
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/store/reducers/error.js